import {useCallback} from "react";

/**
 * Wraps a mouse handler so it only runs for the left (0) and middle (1) buttons.
 * Use it with onMouseDown: middle-click opens links in a new tab before an onClick-based
 * handler (analytics / pending context) could run, so the logic must fire on mousedown.
 */
export const usePrimaryClick = <TElement extends Element = Element, TArgs extends unknown[] = []>(
    handler: (event: React.MouseEvent<TElement>, ...args: TArgs) => void
) =>
    useCallback(
        (event: React.MouseEvent<TElement>, ...args: TArgs) => {
            if (event.button > 1) {
                return;
            }

            handler(event, ...args);
        },
        [handler]
    );
import {useCallback} from "react";

/**
 * Wraps a mouse handler so it only runs for the left (0) and middle (1) buttons.
 * Use it with onMouseDown: middle-click opens links in a new tab before an onClick-based
 * handler (analytics / pending context) could run, so the logic must fire on mousedown.
 */
export const usePrimaryClick = <TElement extends Element = Element, TArgs extends unknown[] = []>(
    handler: (event: React.MouseEvent<TElement>, ...args: TArgs) => void
) =>
    useCallback(
        (event: React.MouseEvent<TElement>, ...args: TArgs) => {
            if (event.button > 1) {
                return;
            }

            handler(event, ...args);
        },
        [handler]
    );
